import {http} from '@/helpers/http-helper';

class Member {
    constructor(
        uuid,
        code,
        name,
        surname,
        sex,
        birthday,
        nif,
        emails,
        phones,
        addresses,
        headquarters,
        shareDataToThirdParties,
        exemptFromPayment,
        active,
        located
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
        this.surname = surname;
        this.sex = sex;
        this.birthday = birthday;
        this.nif = nif;
        this.emails = emails;
        this.phones = phones;
        this.addresses = addresses;
        this.headquarters = headquarters;
        this.shareDataToThirdParties = shareDataToThirdParties;
        this.exemptFromPayment = exemptFromPayment;
        this.active = active;
        this.located = located;
    }
}

export const activateMember = (uuid, date) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + uuid + '/activate';
        http.post(url, {
          activatedAt: date
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deactivateMember = (uuid, unsubscribeReasonId, date) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + uuid + '/deactivate';
        http.post(url, {
            unsubscribeReasonId: unsubscribeReasonId,
            deactivatedAt: date
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const setMemberAsLocated = (uuid) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + uuid + '/located';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const setMemberAsNotLocated = (uuid, sendEmail, emailMessage) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + uuid + '/not-located';
        http.post(url, {
            sendEmail: sendEmail,
            emailMessage: emailMessage
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMemberCardEmail = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/card/email';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data.email);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const sendMemberCardEmail = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/card/email';
        http.post(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMemberCertificatePreview = (memberId, certificateType, year) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/certificate/preview';
        http.post(
            url,
            {
                certificateType: certificateType,
                year: year
            },
            null,
            'blob'
        )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getFeeCertificatePreview = (memberId, certificateType, year, amount, signatureDate) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/fee-certificate/preview';
        http.post(
            url,
            {
                certificateType: certificateType,
                year: year,
                amount: amount,
                signatureDate: signatureDate
            },
            null,
            'blob'
        )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const sendMemberCertificateEmail = (memberId, certificateType, year) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/certificate/send';
        http.post(url, {
            certificateType: certificateType,
            year: year
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const sendFeeCertificateEmail = (memberId, certificateType, year, amount, signatureDate) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId + '/fee-certificate/send';
        http.post(url, {
            certificateType: certificateType,
            year: year,
            amount: amount,
            signatureDate: signatureDate
        })
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const updateMemberCnaes = (uuid, cnaesIds) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + uuid + '/cnae';
        http.post(url, {cnaes: cnaesIds})
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const applyAgreementToMember = (memberId, agreementId, applicationDate) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + memberId + '/agreements/' + agreementId;
        http.post(url, {applicationDate: applicationDate})
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const stopApplyingAgreementToMember = (memberId, agreementId) => {
    return new Promise((resolve, reject) => {
        const url = '/members/' + memberId + '/agreements/' + agreementId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const searchMembers = (filters, page, itemsPerPage) => {
    return new Promise((resolve, reject) => {
        const url = 'members/search';
        http.post(url, filters, {page: page, itemsPerPage: itemsPerPage})
            .then((response) => {
                if (response.status === 200 && !!response.data.members) {
                    resolve(response.data.members);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMember = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = 'members/' + memberId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(new Member(
                        response.data.uuid,
                        response.data.code,
                        response.data.name,
                        response.data.surname,
                        response.data.sex,
                        response.data.birthday,
                        response.data.nif,
                        response.data.emails,
                        response.data.phones,
                        response.data.addresses,
                        response.data.headquarters,
                        response.data.shareDataToThirdParties,
                        response.data.exemptFromPayment,
                        response.data.active,
                        response.data.located
                    ));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
